import { render, staticRenderFns } from "./NoNotification.vue?vue&type=template&id=cbc8a14c&scoped=true&"
import script from "./NoNotification.vue?vue&type=script&lang=js&"
export * from "./NoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc8a14c",
  null
  
)

export default component.exports